import styled from 'styled-components'
import { ColoredIcon } from 'component/ColoredIcon'
import themeAsseticonCloseSvg from '@theme/icon/close.svg'

export const IconClose = styled(ColoredIcon).attrs({
  src: `${themeAsseticonCloseSvg}`,
})`
  height: 0.6rem;
  width: 0.6rem;
  position: absolute;
  top: 0.275rem;
  right: 0.4rem;
`

export const Wrapper = styled.div`
  position: absolute;
  display: grid;
  grid-template-rows: 1fr auto;
  background: var(--component-modal-game-service-background);
  bottom: 0;
  top: 0;
  border-radius: 0.25rem 0.25rem 0 0;
  padding: 0.6rem 0.2rem max(0.6rem, env(safe-area-inset-bottom)) 0.2rem;
  color: var(--component-modal-game-service-color);
  width: 100%;
  font-size: 0.35rem;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  padding-bottom: 0.4rem;
`
